import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";
import { DateRangePicker } from "react-date-range";
import { pt } from "date-fns/locale";
import "../../css/rsuite-timerange-scope.css";
import TimeRangePicker from "../inputs/TimeRangePicker";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import axios from "axios";
import Loader from "../Loader";
import { api } from "../../App";
import {
  fetchOpenClosedExceptions,
  createOpenClosedExceptions,
  fetchPlaceOfTable,
} from "../../actions/restaurantActions";
import styled from "styled-components";
import DropDownButton from "../DropDownButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faCalendar,
  faMapLocation,
  faCircleXmark,
  faClock,
  faUser,
  faSun,
} from "@fortawesome/free-solid-svg-icons";
import { XSvgIcon } from "../../icons/SvgIcons";
import {
  ContainerBox,
  Header,
  Body,
  OrangeButton,
  Title,
  Container,
} from "../DefaultImports";
import TimeInputLessPlus from "../TimeInputLessPlus";
import DropDownButtonTime from "../DropDownButtonTime";
import DropDownButtonInfiniteNumbers from "../inputs/DropDownInfiniteNumbers";
import CustomSelectArray from "../CustomSelectArray";
import SwitchOnAndOff from "../SwitchOnAndOff";
import { Time } from "@rsuite/icons";
import {
  ModernButton,
  InlineText,
  InsideFormGroup,
  FormGroup,
  Input,
  StyledLabel,
} from "../../components/DefaultImports";
import { ConfirmationModal } from "../ConfirmationModal";

const StyledDateRangePicker = styled(DateRangePicker)`
  width: auto;
  margin: 0 auto;
  border-radius: 10px;

  .rdrDefinedRangesWrapper {
    display: none;
  }

  .rdrInRange {
    background: #f79574 !important;
    color: #333 !important;
  }

  .rdrStartEdge,
  .rdrEndEdge {
    background-color: #ff704d !important;
    color: white !important;
  }
  .rdrDayStartPreview,
  .rdrDayEndPreview {
    color: #ff704d !important;
  }
  .rdrDayInPreview {
    color: #ff704d !important;
  }
  .rdrDayNumber span::after {
    background-color: #ff704d !important;
  }

  .rdrMonthAndYearPickers select {
    font-size: 14px;
    color: #4b3335;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 4px 6px;
    height: 30px;
    min-width: 100px;
    text-align: center;
    appearance: none;
  }

  .rdrMonthAndYearPickers option {
    font-size: 16px;
    color: #4b3335;
    text-align: center;
    padding: 6px;
  }

  .rdrMonthAndYearPickers {
    gap: 12px;
    justify-content: center;
    align-items: center;
  }
`;

const OpenClosedExceptions = ({
  restaurant_id,
  type_of_exception,
  exception_id,
  mode,
  setShowModal,
}) => {
  const dispatch = useDispatch();
  const params = useParams();

  const restaurantZones = useSelector((state) => state.restaurantZones);
  const { zones = [] } = restaurantZones;

  const openClosedExceptions = useSelector(
    (state) => state.openClosedExceptions
  );
  const { exceptions } = openClosedExceptions;

  const [isFormReady, setIsFormReady] = useState(false);

  const [zone_list, setZone_list] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [accept_people_per_each_time, setAaccept_people_per_each_time] =
    useState(20);
  const [eachTime, setEachTime] = useState("00:15");
  const [showExceptionDaysDeleteModal, setShowExceptionDaysDeleteModal] =
    useState(false);
  const [switchLimit, setSwitchLimit] = useState(false);
  const [switchZones, setSwitchZones] = useState(
    mode === "create" ? false : true
  );

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [formData, setFormData] = useState({
    restaurant: parseInt(restaurant_id),
    closed_days_start: formatDate(new Date()),
    closed_days_end: formatDate(new Date()),
    start_time: "12:00",
    end_time: "18:00",
    list_of_zones: "",
    accept_people_per_each_time: 20,
    each_time: "00:15",
    type_of_exception: type_of_exception,
  });

  // Helper function to format time
  const formatTime = (timeString) => {
    if (!timeString) return "12:00";
    const time = timeString.slice(0, 5);
    return time.length === 5 ? time : "12:00";
  };

  // Helper function to format date
  function formatDate(date) {
    const d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    return [year, month.padStart(2, "0"), day.padStart(2, "0")].join("-");
  }

  useEffect(() => {
    const placeOfTables = zones.map((zone) => zone.place_of_table);
    setZone_list(placeOfTables);
    if (!switchZones) {
      setSelectedZones(placeOfTables);
    }
  }, [zones, switchZones]);

  useEffect(() => {
    if (mode === "edit" && exceptions.length > 0 && exception_id) {
      const exception = exceptions.find((ex) => ex.id === exception_id);
      if (exception) {
        const startDate = new Date(exception.closed_days_start);
        const endDate = exception.closed_days_end
          ? new Date(exception.closed_days_end)
          : startDate;

        setDateRange([{ startDate, endDate, key: "selection" }]);

        setFormData({
          restaurant: parseInt(restaurant_id),
          closed_days_start: formatDate(startDate),
          closed_days_end: formatDate(endDate),
          start_time: formatTime(exception.start_time),
          end_time: formatTime(exception.end_time),
          list_of_zones: exception.list_of_zones || "",
          accept_people_per_each_time:
            exception.accept_people_per_each_time || "0",
          type_of_exception: exception.type_of_exception,
        });

        setSelectedZones(
          exception.list_of_zones ? exception.list_of_zones.split(",") : []
        );
        setSwitchLimit(exception.type_of_exception === "limited");
        const placeOfTables = zones.map((zone) => zone.place_of_table);
        const exceptionZones = exception.list_of_zones.split(",");
        setSwitchZones(exceptionZones.length < placeOfTables.length);
        setAaccept_people_per_each_time(
          parseInt(exception.accept_people_per_each_time || "0")
        );
        setEachTime(exception.each_time);
      }
    }
    setIsFormReady(true);
  }, [mode, exceptions, exception_id, restaurant_id]);

  useState(() => {
    console.log("formData: ", formData);
  }, [formData]);

  const handleDateRangeChange = (ranges) => {
    setDateRange([ranges.selection]);
    setFormData({
      ...formData,
      closed_days_start: formatDate(ranges.selection.startDate),
      closed_days_end: formatDate(ranges.selection.endDate),
    });
  };

  const handleSelectZones = (newSelectedItems) => {
    setSelectedZones(newSelectedItems);
    setFormData({
      ...formData,
      list_of_zones: newSelectedItems.join(","),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (mode === "edit" && exception_id) {
        await api.put(
          `/restaurants/${restaurant_id}/OpenClosedExceptions/${exception_id}/`,
          formData
        );
      } else {
        dispatch(createOpenClosedExceptions(restaurant_id, formData));
      }
      dispatch(fetchOpenClosedExceptions(restaurant_id));
      setShowModal(false);
    } catch (error) {
      console.error("Error submitting exception:", error);
    }
  };

  const handleExceptionElimination = async () => {
    try {
      await api.delete(
        `/restaurants/${restaurant_id}/OpenClosedExceptions/${exception_id}/`
      );
      dispatch(fetchOpenClosedExceptions(restaurant_id));
      setShowExceptionDaysDeleteModal(false);
      setShowModal(false);
    } catch (error) {
      console.error(error);
    }
  };

  if (!isFormReady) return <Loader />;

  return (
    <div style={{ margin: "0", padding: "0" }}>
      {/* Modal Body */}
      <div>
        <Form onSubmit={handleSubmit}>
          <FormGroup controlId="dateRange">
            <StyledLabel>Data de início e de fim</StyledLabel>

            <StyledDateRangePicker
              ranges={dateRange}
              onChange={handleDateRangeChange}
              minDate={new Date()}
              showDateDisplay={false}
              months={1}
              direction="horizontal"
              locale={pt}
            />
          </FormGroup>

          <FormGroup controlId="timeRange">
            <StyledLabel>Horário</StyledLabel>
            <TimeRangePicker
              startTime={formData.start_time}
              endTime={formData.end_time}
              onChange={(times) => {
                setFormData({
                  ...formData,
                  start_time: times[0],
                  end_time: times[1],
                });
              }}
            />
          </FormGroup>
          {type_of_exception !== "closed_exception" && (
            <>
              <FormGroup>
                <InsideFormGroup>
                  <StyledLabel>Controlar chegada de clientes</StyledLabel>
                  <InlineText>Permitir no total</InlineText>
                  <Input
                    type="number"
                    id="accept_people_per_each_time"
                    name="accept_people_per_each_time"
                    value={accept_people_per_each_time}
                    onChange={(e) => {
                      const value = e.target.value;
                      setAaccept_people_per_each_time(value);
                      setFormData({
                        ...formData,
                        accept_people_per_each_time: value,
                      });
                    }}
                  />
                  <InlineText>pessoas a cada</InlineText>
                  <DropDownButton
                    options={["00:15", "00:30", "00:45"]}
                    handleOptionChange={(selected) => {
                      setEachTime(selected);
                      setFormData({
                        ...formData,
                        each_time: selected,
                      });
                    }}
                    initialOption={eachTime}
                  />
                  <InlineText>minutos</InlineText>
                </InsideFormGroup>
              </FormGroup>

              <FormGroup controlId="zones">
                <StyledLabel>Selecionar salas</StyledLabel>
                <CustomSelectArray
                  items={zone_list}
                  onSelectChange={handleSelectZones}
                  selectedItems={selectedZones}
                  size="large"
                />
              </FormGroup>
            </>
          )}

          <div
            style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
          >
            {mode === "edit" && (
              <ModernButton
                color="#9fbbc1"
                onClick={() => setShowExceptionDaysDeleteModal(true)}
              >
                Apagar
              </ModernButton>
            )}
            <ModernButton color="#ff704d" type="submit">
              Gravar
            </ModernButton>
          </div>
        </Form>
      </div>

      {/* Exception Delete Modal */}
      <ConfirmationModal
        show={showExceptionDaysDeleteModal}
        onHide={() => setShowExceptionDaysDeleteModal(false)}
        onConfirm={handleExceptionElimination}
        title="Eliminar exceção"
        body="Tem a certeza de que deseja eliminar esta exceção?"
        confirmLabel="Eliminar"
        cancelLabel="Cancelar"
        confirmColor="#ff704d"
        cancelColor="#9fbbc1"
        centered={false}
        topSpacing={"250px auto"}
      />
    </div>
  );
};

export default OpenClosedExceptions;
